<ng-template [ngIf]="definisciFascicoloForm">
<div>
	<div class="col-sm-12 coldx">
		<h4 *ngIf="title">{{title}}</h4>
		<p *ngIf="fascicolo?.flagFondoRischi && fascicolo?.tipoFascicolo?.id != 11"
			class="a conferma_accettazione">
			<label>Il Fondo Rischi per il presente
				fascicolo &egrave; impostato a S&igrave;. </label>
				<label>Si ricorda di procedere con
				l'impostazione a No. Clicca qui per accedere alla sezione <a href="javascript:void(0)" (click)="goToDatiGenerali()">Dati
				Generali</a>.</label>
		</p>
		</div>
		<div class="col-sm-12 coldx">
		<form [formGroup]="definisciFascicoloForm" (ngSubmit)="update();">
			<div class="row">		
			   <div datePickerInput class="col-sm-3"
					[control]="definisciFascicoloForm.controls['dataDefinizione']" placeholder="Inserire la data"
					[mandatory]="true" [dataAl]="today"
					[labelInput]="'Data'" formControlName="dataDefinizione"
					[(ngModel)]="request.dataDefinizione"></div>	
<!-- 			</div> -->
<!-- 			<div class="row"> -->
			<div comboModInput [control]="definisciFascicoloForm.controls['motivoDefinizione']"
			[mandatory]="true" class="col-sm-9" [labelInput]="'Motivo'"
			formControlName="motivoDefinizione" [objectReference]="motivoDefinizione"
			[ngModel]="motivoDefinizione"
			(onReturn)="motivoDefinizione = $event"
			[optionsCombo] ="motiviDefinizione"></div>
			</div>
			<div class="row">
				<p class="mandatory col-sm-12"><em>* Campi obbligatori</em></p>
			</div>
			<div class="row">
				<p class="col-sm-3 col-xs-6">
					<button type="button" class="btn btn-outline-secondary btn-block"
						(click)="createForm();">Reset</button>
				</p>
				<p submitButton
					class="col-sm-3 col-xs-6 col-sm-offset-6"
					[labelButton]="'Salva'" [disabled]='!definisciFascicoloForm.valid'>
			</div>
		</form>
	</div>
</div>
</ng-template>
